'use strict';

module.exports = {
	MapModel: require('@mindmup/mapjs-core/src/map-model'),
	content: require('@mindmup/mapjs-core/src/content/content'),
	observable: require('@mindmup/mapjs-core/src/util/observable'),
	DomMapController: require('./browser/dom-map-controller'),
	ThemeProcessor: require('@mindmup/mapjs-core/src/theme/theme-processor'),
	defaultTheme: require('@mindmup/mapjs-core/src/themes/theme-default'),
	formatNoteToHtml: require('@mindmup/mapjs-core/src/content/format-note-to-html'),
	version: 4
};
